/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { TemporaryDrawer, breakpoints } from '@coursera/cds-core';

import UserChangeLogContainer from 'bundles/author-assignment-grading/components/ChangeLog/UserChangeLogContainer';
import type GroupMember from 'bundles/authoring/groups/models/GroupMember';
import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
import type { Team } from 'bundles/grading/components/staff-graded-assignments/types/SGAGradingTypes';
import { generateGroupMembers } from 'bundles/grading/utils/submitterUtils';

const { HeadingGroup, Content } = TemporaryDrawer;

const styles = {
  headingGroup: css`
    ${breakpoints.up('sm')} {
      padding: 0 var(--cds-spacing-400);
    }

    position: absolute;
    right: 0;
  `,
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

// Component for User Change Log Drawer
const UserChangeLogDrawer = ({ isOpen, onClose }: Props) => {
  const { pageData, submissionData } = useContext(SGAPageContext);
  const { submitter, isTeamAssignment } = submissionData.data || {};

  if (!submitter) {
    return null;
  }
  const teamMembers: GroupMember[] = isTeamAssignment
    ? generateGroupMembers((submitter as Team).userProfiles, pageData.currentContextId)
    : [];

  return (
    <TemporaryDrawer
      open={isOpen}
      anchor="right"
      sticky="none"
      width="large"
      onClose={onClose}
      aria-describedby="changelog-content"
      data-testid="changelog-drawer"
    >
      <HeadingGroup css={styles.headingGroup}>
        <React.Fragment />
      </HeadingGroup>
      <Content id="changelog-content">
        <UserChangeLogContainer
          currentItem={pageData.currentItem}
          userId={submitter.id}
          courseBranchId={pageData.courseBranchId}
          isAnonymized={pageData.isAnonymized}
          sessionItem={pageData.sessionItem}
          grades={pageData.gradebookGrades}
          teamMembers={teamMembers}
          refetchGrades
        />
      </Content>
    </TemporaryDrawer>
  );
};

export default UserChangeLogDrawer;
